<template>
  <v-container fluid grid-list-md>
    <!--Dialog para confirmação de exclusão-->
    <p-confirm :text="deleteText" :entity="''" :dialog="dialogConfirm" @confirm="deleteItem" @cancel="closeDialogDelete"></p-confirm>
    <!-- Dialog para confirmação de edição em uma situação em que já existe algum usuário editando a equipe -->
    <p-confirm text="Existem usuários realizando a edição desta parceria, poderá haver conflitos. Deseja continuar" :dialog="confirmEditDialog" @confirm="confirmEdit" @cancel="confirmEditDialog = false"></p-confirm>
    <!--Consult-->
    <!--Foi colocado o v-show para que não suma o filtro do PFilter-->
    <v-layout v-show="!dialog" wrap justify-center align-center>
      <v-flex xs12 sm8>
        <span class="headline"><v-icon large class="mr-1" color="primary">{{this.translate('table.connections.icon')}}</v-icon>{{formTitle}}</span>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field id="connection_search" append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <p-filter
          ref="filter"
          :allItems="allItems"
          :entity="entity"
          :filterTypes="filterTypes"
          @customFilter="(res)=>{items=res}">
        </p-filter>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          disable-initial-sort
          :no-data-text="emptyTable"
          rows-per-page-text="Registros por página"
          :headers="headers"
          :items="items"
          :search="search"
          class="elevation-1"
          :rows-per-page-items="[25,50,100,{'text':'Todos','value':-1}]"
          :custom-filter="customizedFilter" style="word-break: break-all;">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.identifier }}</td>
            <td>{{ props.item.id_text }}</td>
            <td>{{ props.item.cpfcnpj ? maskField(props.item.cpfcnpj, props.item.type_person === 1 ? '###.###.###-##' : '##.###.###/####-##') : '' }}</td>
            <td>
              <v-tooltip bottom>
                <v-icon dark fab slot="activator" :color="translate('value.connection_status').filter(a => a.value === parseInt(props.item.status))[0].color">{{translate('value.connection_status').filter(a => a.value === parseInt(props.item.status))[0].icon}}</v-icon>
                <span>{{translate('value.connection_status').filter(a => a.value === parseInt(props.item.status))[0].text}}</span>
              </v-tooltip>
            </td>
            <td>{{ props.item.phone ? maskField(props.item.phone, '(##) #####-####') : '' }} {{props.item.email}}</td>
            <!-- O campo ativo foi ocultado da tela de parceria. Posteriormente será retrabalhado e voltará a ser exibido -->
            <!-- <td>
              <v-checkbox
                v-model="props.item.active"
                @click.native="editValue(entity,props.item,translate('table.' + entity + '.title')[0],true)"
              ></v-checkbox>
            </!-->
            <td v-if="props.item.status === 1 && props.item.type === 2" align="center" style="min-width: 128px">
              <v-tooltip bottom>
                <v-btn :id="'connection_done_btn_'+props.index" icon slot="activator" class="mx-0" @click=acceptInvite(props.item)>
                  <v-icon color="green">done</v-icon>
                </v-btn>
                <span>
                  Aceitar
                </span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn :id="'connection_close_btn_'+props.index" icon slot="activator" class="mx-0" @click=denyInvite(props.item)>
                  <v-icon color="pink">close</v-icon>
                </v-btn>
                <span>
                  Recusar
                </span>
              </v-tooltip>
            </td>
            <td v-else align="center" style="min-width: 128px">
              <v-tooltip bottom>
                <v-btn :id="'connection_list_btn_'+props.index" icon slot="activator" class="mx-0">
                  <v-icon color="grey darken-1">list</v-icon>
                </v-btn>
                <span>
                  <p-other-field :reload="reload" :othersFields="othersFields(props.item)"></p-other-field>
                </span>
              </v-tooltip>
              <v-menu
                left
                nudge-top="8"
                content-class="elevation-0 menu_content"
                transition="slide-x-reverse-transition"
                :offset-x="true"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn :id="'connection_more_vert_btn_'+props.index" fab small slot="activator" icon class="mx-0" v-on="on">
                    <v-icon medium>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-tooltip bottom v-if="props.item.status === 3">
                  <v-btn :id="'connection_compare_arrows_btn_'+props.index" slot="activator" small color="grey lighten-4" fab class="mx-0" :loading="loading" @click="openConnectionCreate(props.item.id)" :disabled="!checkPermission(entity, 'create')">
                    <v-icon color="accent">compare_arrows</v-icon>
                  </v-btn>
                  <span>Vincular Cliente</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-menu offset-y slot="activator" bottom>
                    <v-btn :id="'connection_library_btn_'+props.index" slot="activator" @click="$refs.connectionDuration.openDialog(props.item.id, props.item.id_text)" small color="grey lighten-4" fab class="mx-0" :disabled="!checkPermission('report_connection', 'view') || props.item.status == 1">
                      <v-icon color="orange">library_books</v-icon>
                    </v-btn>
                    <v-list>
                      <v-list-tile
                        :key="0">
                        <v-list-tile-title>{{checkPermission('report_connection', 'view') ? 'Relatório' : 'Você não tem permissão para visualizar'}}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                  <span>{{props.item.status == 1 ? 'Aguarde o convite ser aceito para tirar o relatório' : 'Relatório de Duração'}}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn :id="'connection_build_btn_'+props.index" slot="activator" small color="grey lighten-4" fab class="mx-0" @click="editItemProcess(props.item, 4)" :disabled="!checkPermission(entity, 'manage')">
                    <v-icon color="teal">build</v-icon>
                  </v-btn>
                  <span>{{ manageTooltipText }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn :id="'connection_delete_btn_'+props.index" slot="activator" small color="grey lighten-4" fab class="mx-0" @click="beforeDialogDelete(props.item)" :disabled="!checkPermission(entity, 'delete')">
                    <v-icon color="pink">delete</v-icon>
                  </v-btn>
                  <span>{{ deleteTooltipText }}</span>
                </v-tooltip>
              </v-menu>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!-- ---------- -->
    <v-form v-if="dialog" v-model="valid" @keyup.native.ctrl.enter="saveProcess(4)" ref="form">
      <v-layout wrap justify-center align-center>
        <v-flex xs12 sm7>
          <span class="headline"><v-icon large class="mr-1" color="primary">{{this.translate(`table.${this.entity}.icon`)}}</v-icon>{{formTitle}}</span>
        </v-flex>
        <v-flex xs12 sm3>
          <v-checkbox id="connection_auto" :disabled="view === 4" v-model="editedItem.auto" label="Busca automática dos dados da outra empresa" v-show="(editedItem.status === 2)" @change="getCompanyData"></v-checkbox>
        </v-flex>
        <v-flex xs12 sm2 class="text-xs-right">
          <p-edit-btn :tooltipText="editTooltipText" v-if="view === 4" @onClick="checkEditRoomEmpty(editedItem, 3)" :disabled="!checkPermission(entity, 'edit')">
          </p-edit-btn>
        </v-flex>
        <!--Management-->
        <v-container fluid grid-list-xs style="padding: 2px" v-if="view === 4">
          <div class="p-gradient">
            <v-layout row wrap>
              <v-flex xs12 md4>
                <div class="p-white text-xs-center">
                  <v-avatar size="150px" v-ripple v-if="editedItem.auto" class="grey lighten-5">
                    <img v-if="editedItem['connection_company']['logo_path']" :src="`${basePath}uploads/companies/${editedItem['connection_company']['logo_path']}`" alt="avatar">
                    <span v-else>Imagem buscada do parceiro</span>
                  </v-avatar>
                  <v-avatar size="150px" v-ripple v-else class="grey lighten-5">
                    <img v-if="editedItem.logo_path" :src="`${basePath}uploads/connections/${editedItem.logo_path}`" alt="avatar">
                    <span v-else>Não existe foto</span>
                  </v-avatar>
                </div>
              </v-flex>
              <v-flex xs12 md8>
                <v-layout row wrap justify-center>
                  <v-flex xs12 sm3>
                    <div class="p-white">
                      <div class="p-label">{{translate('table.' + entity + '.field.identifier')}}</div>
                      <div class="p-content">{{editedItem.identifier}}</div>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm9>
                    <div class="p-white">
                      <div class="p-label">{{name_label}}</div>
                      <div class="p-content">{{editedItem.id_text}}</div>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <div class="p-white">
                      <div class="p-label">{{cpfcnpj_label}}</div>
                      <div class="p-content">{{maskField(editedItem.cpfcnpj, cpfcnpj_mask)}}</div>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm7>
                    <div class="p-white">
                      <div class="p-label">{{rgie_label}}</div>
                      <div class="p-content">{{editedItem.rgie}}</div>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <div class="p-white">
                      <div class="p-label">{{translate('table.' + entity + '.field.city')}}</div>
                      <div class="p-content"> {{editedItem.city ? (editedItem.city + ', ' + editedItem.state + ', ' + editedItem.country) : ''}}</div>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <div class="p-white">
                      <div class="p-label">{{translate('table.' + entity + '.field.cep')}}</div>
                      <div class="p-content">{{editedItem.cep}}</div>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <div class="p-white">
                      <div class="p-label">{{translate('table.' + entity + '.field.neighborhood')}}</div>
                      <div class="p-content">{{editedItem.neighborhood}}</div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm4>
                <div class="p-white">
                  <div class="p-label">{{translate('table.' + entity + '.field.complement')}}</div>
                  <div class="p-content">{{editedItem.complement}}</div>
                </div>
              </v-flex>
              <v-flex xs12 sm6>
                <div class="p-white">
                  <div class="p-label">{{translate('table.' + entity + '.field.address')}}</div>
                  <div class="p-content">{{editedItem.address}}</div>
                </div>
              </v-flex>
              <v-flex xs12 sm2>
                <div class="p-white">
                  <div class="p-label">{{translate('table.' + entity + '.field.number')}}</div>
                  <div class="p-content">{{editedItem.number}}</div>
                </div>
              </v-flex>
              <v-flex xs12 md6>
                <div class="p-white">
                  <div class="p-label">{{translate('table.' + entity + '.field.phone')}}</div>
                  <div class="p-content">{{maskField(editedItem.phone, '(##) #####-####')}}</div>
                </div>
              </v-flex>
              <v-flex xs12 md6>
                <div class="p-white">
                  <div class="p-label">{{translate('table.' + entity + '.field.email')}}</div>
                  <div class="p-content">{{editedItem.email}}</div>
                </div>
              </v-flex>
              <v-flex xs12>
                <div class="p-white">
                  <div class="p-label">{{translate('table.' + entity + '.field.note')}}</div>
                  <div class="p-content" style="white-space: pre-line;">{{editedItem.note}}</div>
                </div>
              </v-flex>
              <v-flex xs12 md4 v-for="(customField, index) in editedItem['customFields']" :key="index">
                <div class="p-white">
                  <div class="p-label">{{customField['title']}}</div>
                  <div class="p-content">{{getCustomFieldValue(customField)}}</div>
                </div>
              </v-flex>
              <v-flex v-if="editedItem['customFields'] && (editedItem['customFields'].length % 3 >= 1)" :class="'xs12 md' + (8 / (editedItem['customFields'].length % 3))">
                <div class="p-white"></div>
              </v-flex>
              <!-- O campo ativo foi ocultado da tela de parceria. Posteriormente será retrabalhado e voltará a ser exibido -->
              <!-- <v-flex xs12>
                <div class="p-white">
                  <div class="p-label">{{translate('table.' + entity + '.field.active')}}</div>
                  <div class="p-content">{{translate('system.bollean')[editedItem.active]}}</div>
                </div>
              </v-flex> -->

            </v-layout>
          </div>
        </v-container>

        <!--Create Edit-->
        <v-container fluid grid-list-xs style="padding: 2px" v-else>
            <v-layout row justify-space-between wrap>
              <v-flex xs12 sm4>
                <div class="text-xs-center">
                  <p-upload-cropped-image id="connection_logo_path" v-model="editedItem.logo_path" @changeImage="changeImage" :disabled="editedItem.auto">
                    <div slot="activator">
                      <v-avatar size="150px" v-ripple v-if="editedItem.auto" class="grey lighten-5">
                        <img v-if="editedItem['connection_company']['logo_path']" :src="`${basePath}uploads/companies/${editedItem['connection_company']['logo_path']}`" alt="avatar">
                        <span v-else>Imagem buscada do parceiro</span>
                      </v-avatar>
                      <v-avatar size="150px" v-ripple v-else class="grey lighten-5">
                        <img v-if="editedItem.logo_path" :src="blobImage?editedItem.logo_path:`${basePath}uploads/connections/${editedItem.logo_path}`" alt="avatar">
                        <span v-else>Clique para adicionar uma foto</span>
                      </v-avatar>
                    </div>
                  </p-upload-cropped-image>
                </div>
              </v-flex>
              <v-flex xs12 sm8>
                <v-layout row wrap justify-center align-center>
                  <v-flex xs12 sm4 v-show="view === 3">
                    <v-text-field id="connection_identifier" :label="translate('table.' + entity + '.field.identifier')" name="codigo" readonly v-model="editedItem.identifier"
                    ></v-text-field>
                  </v-flex>
                  <v-flex :class="view === 3 ? 'xs12 sm8' : 'xs12'">
                    <v-text-field id="connection_id_text" maxlength="190" counter="190"  :label="name_label" name="id_text" :rules="requiredRule('Nome',190)" v-model="editedItem.id_text" :disabled="editedItem.status != 3"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-select id="connection_type_person" :content-class="'connection_type_person_class'" @input="labels" :label="translate('table.' + entity + '.field.type_person')" name="type_person" :disabled="editedItem.status != 3" v-model="editedItem.type_person" :rules="requiredRule(translate('table.' + entity + '.field.type_person'))" :items="translate('value.connection_type_person')"></v-select>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field id="connection_cpfcnpj" :label="cpfcnpj_label" name="cpfcnpj" :rules="fixedSizeRule(cpfcnpj_label, editedItem.type_person == 1 ? 11 : 14, false)" :mask="cpfcnpj_mask" :disabled="editedItem.status != 3" validate-on-blur v-model="editedItem.cpfcnpj"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field id="connection_rgie" :label="rgie_label" name="rgie" :disabled="editedItem.auto" maxlength="190" counter="190" v-model="editedItem.rgie">
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm6>
                <vuetify-google-autocomplete
                    ref="address"
                    id="googleMap"
                    v-model="editedItem.googleMap"
                    :disabled="editedItem.auto"
                    append-icon="search"
                    placeholder="Selecione uma Cidade"
                    label="Cidade"
                    types='(cities)'
                    clearable
                    v-on:blur="controlGoogleAutocomplete"
                    v-on:placechanged="getCityData"
                >
                </vuetify-google-autocomplete>
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field id="connection_cep" :label="translate('table.' + entity + '.field.cep')" :disabled="editedItem.auto" v-model="editedItem.cep" mask="#####-###">
               </v-text-field>
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field id="connection_neighborhood" :label="translate('table.' + entity + '.field.neighborhood')" name="neighborhood" :disabled="editedItem.auto" maxlength="190" counter="190" v-model="editedItem.neighborhood">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field id="connection_complement" maxlength="190" counter="190" :label="translate('table.' + entity + '.field.complement')" name="complement" :disabled="editedItem.auto" v-model="editedItem.complement">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field id="connection_address" :label="translate('table.' + entity + '.field.address')" name="address" :disabled="editedItem.auto" maxlength="190" counter="190" v-model="editedItem.address">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm2>
                <v-text-field id="connection_number" :label="translate('table.' + entity + '.field.number')" name="number" :disabled="editedItem.auto" maxlength="190" counter="190" v-model="editedItem.number">
                </v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field id="connection_phone" maxlength="190" counter="190" :label="translate('table.' + entity + '.field.phone')" :disabled="editedItem.auto" v-model="editedItem.phone" mask='(##) #####-####'
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field id="connection_email" maxlength="190" counter="190" :label="translate('table.' + entity + '.field.email')" :disabled="editedItem.auto" v-model="editedItem.email" :rules="emailRule(translate('table.' + entity + '.field.email'), false, false)"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea id="connection_note" :label="translate('table.' + entity + '.field.note')" maxlength="10000" counter="10000" auto-grow  v-model="editedItem.note">
                </v-textarea>
              </v-flex>
              <!-- Campos personalizados -->
            <v-flex xs12 style="border: 2 0 0 0 #cecece;">
                <!-- coloca o originView como 3 (edição) para que a inclusão/edição dos campos personalizados sejam feitos corretamente já que eles são adicionados para a empresa e não por cliente -->
                <p-custom-field ref="PCustomField" :origin_field_name="'connection_id'" :originView="3"></p-custom-field>
              </v-flex>
              <!-- O campo ativo foi ocultado da tela de parceria. Posteriormente será retrabalhado e voltará a ser exibido -->
              <!-- <v-flex xs12>
                <v-switch id="connection_active" :label="translate('table.' + entity + '.field.active')"
                          v-model="editedItem.active"></v-switch>
              </v-flex> -->
            </v-layout>
        </v-container>
      </v-layout>
    </v-form>
    <v-layout v-if="view === 1"  class="fab-container" align-center>
      <v-speed-dial open-on-hover>
        <v-tooltip left slot="activator">
          <v-btn id="connection_add_btn" slot="activator" color="primary" fab @click="create" :loading="loading" :disabled="!checkPermission(entity, 'create') || !checkPlanAccess(entity, 'not_connected', allItems.filter((val) => { return val.status === 3 }).length)">
            <v-icon>{{this.translate('system.button.add.icon')}}</v-icon>
          </v-btn>
          <span>{{!checkPermission(entity, 'create') ? createTooltipText : ('Adicionar '+this.translate('table.' + this.entity + '.title')[0])}}</span>
        </v-tooltip>
        <v-tooltip left>
          <v-btn id="connection_add_connec_btn" slot="activator" fab color="accent" small :loading="loading" @click="openConnectionCreate()" :disabled="!checkPermission(entity, 'create')">
            <v-icon>compare_arrows</v-icon>
          </v-btn>
          <span>{{!checkPermission(entity, 'create') ? createTooltipText : ('Convidar '+this.translate('table.' + this.entity + '.title')[0])}}</span>
        </v-tooltip>
      </v-speed-dial>
    </v-layout>

    <v-layout v-else class="fab-container" align-center>
      <v-speed-dial v-if="view === 2" v-model="fab" open-on-hover>
        <v-tooltip left slot="activator">
          <v-btn id="connection_save_manage_btn" v-model="fab" slot="activator" fab color="primary" :loading="loading" dark @click="saveProcess(4)">
            <v-icon>{{this.translate('system.button.save.icon')}}</v-icon>
            <v-icon>{{this.translate('system.button.build.icon')}}</v-icon>
          </v-btn>
          <span>{{this.translate('system.button.save_manage.title')}}</span>
        </v-tooltip>

        <v-tooltip left>
          <v-btn id="connection_save_close_btn" slot="activator" fab small color="accent" :loading="loading" @click="saveProcess()">
            <v-icon>{{this.translate('system.button.save_close.icon')}}</v-icon>
          </v-btn>
          <span>{{this.translate('system.button.save_close.title')}}</span>
        </v-tooltip>

        <v-tooltip left>
          <v-btn id="connection_save_new_btn" slot="activator" fab small color="secondary" :loading="loading" @click="saveProcess(2)" :disabled="!checkPermission(entity, 'create') || !checkPlanAccess(entity, 'not_connected', allItems.filter((val) => { return val.status === 3 }).length + 1)">
            <v-icon>{{this.translate('system.button.save_new.icon')}}</v-icon>
          </v-btn>
          <span>{{this.translate('system.button.save_new.title')}}</span>
        </v-tooltip>
      </v-speed-dial>

      <v-tooltip top>
        <v-btn id="connection_done_btn" slot="activator" v-if="view === 3" color="primary" :loading="loading" dark fab @click="saveProcess(4)">
          <v-icon>{{this.translate('system.button.done.icon')}}</v-icon>
        </v-btn>
        <span>{{this.translate('system.button.done.title')}}</span>
      </v-tooltip>

      <v-tooltip top>
        <v-btn id="connection_close_btn" slot="activator" fab small @click="close">
          <v-icon>{{this.translate('system.button.close.icon')}}</v-icon>
        </v-btn>
        <span>{{this.translate('system.button.close.title')}}</span>
      </v-tooltip>
    </v-layout>
    <p-connection-duration ref="connectionDuration"></p-connection-duration>
    <p-connection-created ref="connectionCreated" :values="allItems" @saveItem="saveItem" @becomeConnected="becomeConnected"></p-connection-created>
  </v-container>
</template>

<style scoped>
  tr td:last-child {
    min-width: 170px;
  }
  .menu_content {
    padding: 0 10px 10px 10px;
  }
  .fab-container {
    position: fixed;
    bottom: 16px;
    right: 16px;
    z-index: 4;
  }
  .p-content{
    word-break: break-all;
  }
  .speed-dial {
    display:inline !important;
    /*float:right !important;*/
  }
</style>

<script>
  import PEditBtn from './shared/PEditBtn.vue'
  import socket from '../mixin/socket'
  import crud from '../mixin/crud'
  import rules from '../mixin/rules'
  import access from '../mixin/access'
  import mask from '../mixin/mask'
  import tooltip from '../mixin/tooltip'
  import PFilter from './shared/PFilter'
  import POtherField from './shared/POtherField'
  import PUploadCroppedImage from './shared/PUploadCroppedImage'
  import PConfirm from './shared/PConfirm'
  import PConnectionCreated from './shared/PConnectionCreated'
  import PConnectionDuration from './reports/PConnectionDuration'
  import PCustomField from './shared/PCustomField'
  import moment from 'moment'

  export default {
    mixins: [crud, access, rules, mask, socket, tooltip],
    components: {PFilter, PUploadCroppedImage, PEditBtn, POtherField, PConfirm, PConnectionCreated, PConnectionDuration, PCustomField},
    data: () => ({
      dialog_connection_duration: false,
      address: {},
      entity: 'connections',
      deleteText: '',
      fab: null,
      reload: false,
      image: '',
      blobImage: false,
      basePath: process.env.API,
      cpfcnpj_mask: '###.###.###-##',
      cpfcnpj_label: 'CPF',
      rgie_label: 'RG',
      tab: null,
      name_label: 'Nome',
      report_link: `${process.env.API}api/report/connection_duration`,
      confirmEditDialog: false
    }),
    created () {
      this.$store.commit('loader/change_dialog', true)
      this.editedItem = {identifier: '', company_id: '', type: '', country: '', state: '', city: '', id_text: '', type_person: 2, cpfcnpj: '', rgie: '', address: '', number: '', neighborhood: '', complement: '', cep: '', active: true, note: '', connection_company_id: '', connection_id: '', status: '', auto: false, phone: '', email: '', googleMap: '', logo_path: ''}
      this.defaultItem = {identifier: '', company_id: '', type: '', country: '', state: '', city: '', id_text: '', type_person: 2, cpfcnpj: '', rgie: '', address: '', number: '', neighborhood: '', complement: '', cep: '', active: true, note: '', connection_company_id: '', connection_id: '', status: '', auto: false, phone: '', email: '', googleMap: '', logo_path: ''}
      this.initialize()
    },
    mounted () {
      this.$socket.emit('joinRoom', {room: `${this.entity}${this.$auth.user().company_id}`})
    },
    methods: {
      checkEditRoomEmpty (item, view) {
        this.$socket.emit('checkRoomEmpty', {room: `${this.socketRoom}_${item.id}`, user_id: this.$auth.user().id, view: view})
      },
      confirmEdit () {
        this.editItem(this.editedItem, 3)
        this.confirmEditDialog = false
      },
      beforeDialogDelete (item) {
        this.deleteText = item.status !== 2 ? 'Todos os campos que possuem esse parceiro serão apagados, tem certeza que deseja continuar' : 'Todos os campos que possuem esse parceiro serão apagados e a conexão será desfeita, tem certeza que deseja continuar'
        this.dialogDelete(item)
      },
      beforeEditItem (item, view) {
        this.$socket.emit('joinRoom', {room: `${this.entity}${item.company_id}_${item.id}${view === 3 ? '_edit' : ''}`, user_id: this.$auth.user().id, view: view})
      },
      saveProcess (viewAfterSave = 1) {
        console.log('saveProcess')
        if (this.$refs.form && !this.$refs.form.validate()) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'error',
            dialog: true
          })
          return false
        }
        this.$store.commit('loader/change_dialog', true)
        // insere os campos personalizados para mandar pro back e salvar os dados
        this.editedItem['customFields'] = this.$store.state['customFieldConnection'].values
        if (this.image) {
          this.$http.post('api/connection/upload', this.image).then(res => {
            this.blobImage = false
            this.editedItem.logo_path = res.bodyText
            console.log(res.bodyText)
            this.save(viewAfterSave)
          }, err => {
            console.log(err)
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível incluir o registro, reporte o erro.',
              color: 'error',
              dialog: true
            })
          })
        } else {
          this.save(viewAfterSave)
        }
      },
      afterUpdate (newValues) {
        if (newValues['reloadBoards']) {
          let reloadBoards = JSON.parse(JSON.stringify(newValues['reloadBoards']))
          // Apos armazenar o reloadBoards, tira ele do newValues pois ele so serve para mandar o socket
          delete newValues['reloadBoards']
          reloadBoards.forEach(item => {
            // Atualiza todos os boards iguais
            this.$socket.emit('generalEvent', {
              data: {values: item, type: 'taskClients'},
              notBroadcast: true,
              responseEvent: 'socketReloadBoards',
              room: `selectedBoard${item['id']}`
            })
          })
        }
        // * Evento enviado para atualizar o registro para os usuários que estiverem na tela de gerenciamento
        this.$socket.emit('generalEvent', {
          data: {values: newValues, entity: 'parceria'},
          responseEvent: 'editSocketManagementDetails',
          room: `${this.socketRoom}_${newValues.id}`
        })
        // * Evento enviado para atualizar o registro para os usuários que estiverem na tela de consulta
        this.$socket.emit('generalEvent', {
          data: newValues,
          responseEvent: 'editSocketItem',
          room: this.socketRoom
        })
      },
      afterClose (oldValues) {
        if (this.view === 1) {
          this.$socket.emit('leaveRoom', {room: `connections${this.$auth.user().company_id}_${oldValues.id}`})
        }
      },
      initialize () {
        this.$store.commit('loader/change_dialog', true)
        this.$http.get(`api/connection_consult`).then(res => {
          this.items = JSON.parse(JSON.stringify(res.body))
          this.allItems = JSON.parse(JSON.stringify(res.body))
          // Ao abrir a tela verifica se a empresa do usuário não passou do limite do
          this.checkQtdAccess(this.entity, this.allItems.filter((val) => { return val.status === 3 }).length, true, this.getterAccesses, 'not_connected')
          this.afterInitialize(res.body)
        }, err => {
          console.log(err)
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possível carregar os registros, reporte o erro.',
            color: 'error',
            dialog: true
          })
        })
      },
      changeImage (val) {
        this.image = val
        this.blobImage = true
      },
      saveItem (item) {
        item.id_text = `${item.connection_company.id_text} ${item.connection_company.illis_name ? '(' + item.connection_company.illis_name + ')' : ''}`
        this.items.push(item)
        this.allItems.push(item)
        this.afterInsert(item, 2)
      },
      // Trasnforma um registro sem conexão em conectado
      becomeConnected (item) {
        Object.assign(this.items.find((val) => { return val.id === item.id }) || {}, item)
        Object.assign(this.allItems.find((val) => { return val.id === item.id }) || {}, item)
        this.afterInsert(item, 3)
      },
      afterInsert (newValues, type = 1) {
        // ! type 1 => cliente sem conexão | type 2 => cliente conectado | type 3 => cliente vinculado
        if (type === 1) {
          // Para limitar a quantidade de clientes não conectados
          this.checkQtdAccess(this.entity, this.allItems.filter((val) => { return val.status === 3 }).length, true, this.getterAccesses, 'not_connected')
        }
        // * Se o objeto "newValues" não tiver a propriedade connection_company_id significa que o registro adicionado não é uma conexão com outra empresa mas sim a adição de um cliente.
        if (!newValues.connection_company_id) {
          // * Emite o evento para todos da empresa, em caso de adição de cliente, e não de convite de conexão
          this.$socket.emit('generalEvent', {
            data: newValues,
            responseEvent: 'addSocketItem',
            room: this.socketRoom
          })
        } else {
          // * Emite o evento para todos da empresa que enviou o convite. (Todos que estão na tela de conexão no momento)
          this.$socket.emit('generalEvent', {
            data: newValues,
            // * Se type for 3 devemos editar o registro pois ele já existia como cliente não conectado, se type for diferente de 3 adicionamos um novo registro
            responseEvent: type === 3 ? 'editSocketItem' : 'addSocketItem',
            room: this.socketRoom
          })
          // * Emite o evento para todos da empresa que estão editando a conexao que foi vinculada
          this.$socket.emit('generalEvent', {
            data: {values: newValues, entity: 'parceria'},
            responseEvent: 'editSocketManagementDetails',
            room: `${this.socketRoom}_${newValues.id}`
          })
          let company = this.$auth.user().company
          // * Montando objeto que será enviado no evento socket para adição na tela do convite à tela de consulta de todos os participantes empresa convidada.
          let values = {
            'active': true,
            'identifier': null,
            'status': 1,
            'type': 2,
            'type_person': 2,
            'id_text': `${company.id_text} ${company.illis_name ? '(' + company.illis_name + ')' : ''}`, // Nome da empresa que enviou o convite (fornecedora)
            'cpfcnpj': company.cpfcnpj, // CPF/CNPJ da empresa que enviou o convite (fornecedora)
            'company_id': newValues.connection_company_id, // Id da empresa que recebeu o convite (cliente)
            'connection_company_id': company.id, // Id da empresa que enviou o convite (fornecedora)
            'connection_id': newValues.id, // Id do registro de conexão que está sendo enviado neste momento
            'id': newValues.connection_id
          }
          // * Emite o evento para todos os participantes da empresa que recebeu o convite
          this.$socket.emit('generalEvent', {
            data: values,
            responseEvent: 'addSocketItem',
            room: `${this.entity}${values.company_id}`
          })
        }
        // Refaz o filtro depois que insere
        this.redoFilter(this.allItems)
      },
      openConnectionCreate (exist = null) {
        this.$refs.connectionCreated.openConnectionCreate(exist)
      },
      acceptInvite (item) {
        this.$store.commit('loader/change_dialog', true)
        // Aceitar o convite de parceria
        let items = {id: item.id, company_id: item.company_id, connection_id: item.connection_id, connection_company_id: item.connection_company_id}
        this.$http.post(`api/accept_connection`, items).then((res) => {
          res.body.id_text = `${res.body.connection_company.id_text} ${res.body.connection_company.illis_name ? '(' + res.body.connection_company.illis_name + ')' : ''}`
          Object.assign(this.items.find((val) => { return val.id === res.body.id }) || {}, JSON.parse(JSON.stringify(res.body)))
          Object.assign(this.allItems.find((val) => { return val.id === res.body.id }) || {}, JSON.parse(JSON.stringify(res.body)))
          setTimeout(() => {
            this.reload = !this.reload
          }, 1000)
          this.afterUpdate(res.body)

          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', {
            text: 'Convite aceito com sucesso!', color: 'success', dialog: true
          })
          // Evento enviado para os participantes da empresa que CONVIDOU
          this.$socket.emit('generalEvent', {
            data: {id: item.connection_id, status: 2, company_id: item.connection_company_id},
            responseEvent: 'editSocketItem',
            room: `connections${item.connection_company_id}`
          })
          // Evento enviado para os participantes da empresa CONVIDADA
          this.$socket.emit('generalEvent', {
            data: {id: item.id, id_text: item.id_text, status: 2, company_id: item.company_id},
            responseEvent: 'editSocketItem',
            room: `connections${item.company_id}`
          })
        },
        er => {
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possível aceitar o convite.', color: 'error', dialog: true
          })
        })
      },
      afterDelete (oldValues) {
        // usado o beforeEditedItem pois no afterDelete os valores já não possuem connection_id e connection_company_id
        switch (this.beforeEditedItem.status) {
          case 1: {
            if (this.beforeEditedItem.type === 2) {
              // * Se o status do registro for 1 e o tipo for 2, significa que eu estou negando um convite. Pois, se na minha tela, o registro tem o tipo 2 significa que eu sou o cliente e a empresa que me convidou é o meu fornecedor. Então eu estou recusando um convite.
              this.$socket.emit('generalEvent', {
                data: {id: this.beforeEditedItem.connection_id, status: 3, connection_id: null, connection_company_id: null},
                responseEvent: 'editSocketItem',
                room: `${this.entity}${this.beforeEditedItem.connection_company_id}`
              })
              this.$socket.emit('generalEvent', {
                data: {id: this.beforeEditedItem.id},
                responseEvent: 'deleteSocketItem',
                room: this.socketRoom
              })
            } else {
              // * Se o status do registro for 1 e o tipo for 1, significa que eu estou excluindo um convite que ainda está aguardando resposta. Pois se na minha tela, o registro tem o tipo 1 significa que eu sou o fornecedor e a empresa que eu convidei é o meu cliente. Então eu estou excluindo um convite.
              this.$socket.emit('generalEvent', {
                data: {id: this.beforeEditedItem.connection_id},
                responseEvent: 'deleteSocketItem',
                room: `${this.entity}${this.beforeEditedItem.connection_company_id}`
              })
              this.$socket.emit('generalEvent', {
                data: {id: this.beforeEditedItem.id},
                responseEvent: 'deleteSocketItem',
                room: this.socketRoom
              })
            }
            break
          }
          case 2: {
            // * Se o status do registro for 2, significa que o convite foi aceito pela empresa mas posteriormente foi deletado.
            if (this.beforeEditedItem.type === 1) {
              // * Evento para excluir para todos da empresa fornecedora
              this.$socket.emit('generalEvent', {
                data: {id: this.beforeEditedItem.id},
                responseEvent: 'deleteSocketItem',
                room: this.socketRoom
              })
              // * Evento alterado para todos da empresa cliente para não conectado
              this.$socket.emit('generalEvent', {
                data: {id: this.beforeEditedItem.connection_id, status: 3, connection_id: null, connection_company_id: null},
                responseEvent: 'editSocketItem',
                room: `${this.entity}${this.beforeEditedItem.connection_company_id}`
              })
              // evento para forçar a recarga da pagina a todos os clientes deste fornecedor que estiverem na tela de configuração
              this.$socket.emit('generalEvent', {
                data: {text: 'Esta conexão perdeu o vinculo. Será necessário recarregar a página.'},
                responseEvent: 'reloadPageModules',
                room: `${this.entity}${this.beforeEditedItem.connection_company_id}_${this.beforeEditedItem.connection_id}`
              })
            } else {
              // * Evento para excluir para todos da empresa cliente
              this.$socket.emit('generalEvent', {
                data: this.beforeEditedItem,
                responseEvent: 'deleteSocketItem',
                room: this.socketRoom
              })
              // * Evento para editar para todos da empresa fornecedora
              this.$socket.emit('generalEvent', {
                data: {id: this.beforeEditedItem.connection_id, type: 1, status: 3, connection_id: null, connection_company_id: null},
                responseEvent: 'editSocketItem',
                room: `${this.entity}${this.beforeEditedItem.connection_company_id}`
              })
              // evento utilizado para alteração de editItem da empresa fornecedora quando está gerenciando item
              let values = {id: this.beforeEditedItem.connection_id, type: 1, status: 3, connection_id: null, connection_company_id: null}
              this.$socket.emit('generalEvent', {
                data: {entity: 'parceria', values: values},
                responseEvent: 'editSocketManagementDetails',
                room: `${this.entity}${this.beforeEditedItem.connection_company_id}_${this.beforeEditedItem.connection_id}`
              })
            }
            break
          }
          default: {
            // * Se o status for 3, significa que não há conexão e é somente um cliente. Então simplesmente exclui o registro.
            this.$socket.emit('generalEvent', {
              data: this.beforeEditedItem,
              responseEvent: 'deleteSocketItem',
              room: this.socketRoom
            })
          }
        }
        // evento para forçar recarga de pagina para todos os usuarios na tela de edição desta conection
        this.$socket.emit('generalEvent', {
          data: {text: 'Esta conexão foi excluída. Será necessário recarregar a página.'},
          responseEvent: 'reloadPageModules',
          room: `${this.entity}${this.beforeEditedItem.company_id}_${this.beforeEditedItem.id}`
        })
      },
      denyInvite (item) {
        this.editedItem = item
        this.deleteItem()
      },
      // Função controlGoogleAutocomplete criada para que quando o campo do Google Atutocomplete seja zerado, ele realmente limpe os valores, ou atribua o valor
      // correto caso o usuário mude para um valor qualquer
      controlGoogleAutocomplete () {
        if (document.getElementById('googleMap').value === '') {
          this.$refs.address.clear()
          this.editedItem = Object.assign(this.editedItem, {city: '', state: '', country: ''})
        } else {
          let googleMap = this.editedItem.googleMap
          // Inserido o recebimento de vazio, pois quando tenta passar o googleMap direto, considera que o valor é o mesmo e não altera
          this.$refs.address.update(' ')
          // Inserido o tempo para dar tempo do update acima se concluir
          setTimeout(() => {
            this.$refs.address.update(googleMap)
          }, 100)
        }
      },
      getCityData (addressData, placeResultData, id) {
        this.address = addressData
        if (addressData) {
          this.setAddress(addressData.locality, addressData.administrative_area_level_1, addressData.country)
        }
      },
      setAddress: function (city, state, country) {
        setTimeout(() => {
          if (this.$refs.address) {
            this.$refs.address.update(`${city ? `${city}, ` : ``}${state ? `${state}, ` : ``}${country || ``}`)
            Object.assign(this.editedItem, {city: city, state: state, country: country})
          }
        }, 200)
      },
      beforeCreate () {
        Object.assign(this.defaultItem, {status: 3, type: 1})
        // Inicializa como pessoa juridicas os campos referente ao tipo da pessoa
        if (this.$refs.address) {
          this.$refs.address.clear()
        }
        this.labels(2)
      },
      afterCreate () {
        // setTimeout para dar tempo de carregar
        setTimeout(() => {
          // carrega os campos personalizados
          if (this.$refs.PCustomField) {
            // O originView sempre vai com 3 para sempre carregar os valores já que eles vão vir de acordo com a empresa
            this.$refs.PCustomField.getCustomFields('connection_id', 0, 0, 3, this.editedItem['id'])
          }
        }, 100)
      },
      afterEditItem (item) {
        // setTimeout para dar tempo de carregar
        setTimeout(() => {
          // carrega os campos personalizados
          if (this.$refs.PCustomField) {
            // O originView sempre vai com 3 para sempre carregar os valores já que eles vão vir de acordo com a empresa
            this.$refs.PCustomField.getCustomFields('connection_id', 0, 0, 3, this.editedItem['id'])
          }
        }, 100)
        // Preenche o campo de cidade
        this.setAddress(item.city, item.state, item.country)
        // o evento input não é acionado ao abrir a tela de inclusão/edição, por isso a chamada do evento labels com o tipo da pessoa da conexão
        this.labels(item.type_person)
      },
      getCustomFieldValue (customField) {
        switch (customField['type']) {
          case 'select':
            return customField['value_item'] ? customField['value_item']['id_text'] : ''
          case 'multiselect':
            return (Array.isArray(customField['value_item'])) ? customField['value_item'].map((val) => { return val['id_text'] }).toString() : ''
          case 'date':
            return customField['value'] ? moment(customField['value']).format('DD/MM/YYYY') : ''
          case 'value':
            return customField['value'] ? 'R$ ' + parseFloat(customField['value']).toLocaleString('pt-BR') : ''
          default:
            return customField['value'] ? customField['value'] : ''
        }
      },
      labels (val) {
        setTimeout(() => {
          switch (val) {
            case 1:
              this.editedItem.cpfcnpj = this.editedItem.cpfcnpj ? this.editedItem.cpfcnpj.substring(0, 11) : ''
              this.cpfcnpj_mask = '###.###.###-##'
              this.name_label = 'Nome'
              this.cpfcnpj_label = 'CPF'
              this.rgie_label = 'RG'
              break
            case 2:
              this.cpfcnpj_mask = '##.###.###/####-##'
              this.name_label = 'Nome'
              this.cpfcnpj_label = 'CNPJ'
              this.rgie_label = 'IE'
              break
          }
        }, 300)
      },
      othersFields (item) {
        return [
          {field: this.translate('table.' + this.entity + '.field.type_person'), value: item.type_person ? (this.translate('value.connection_type_person').filter(a => a.value === parseInt(item.type_person))[0].text) : ''},
          {field: this.translate('table.' + this.entity + '.field.rgie'), value: item.rgie ? item.rgie : ''},
          {field: this.translate('table.' + this.entity + '.field.country'), value: item.country ? item.country : ''},
          {field: this.translate('table.' + this.entity + '.field.state'), value: item.state ? item.state : ''},
          {field: this.translate('table.' + this.entity + '.field.city'), value: item.city ? item.city : ''},
          {field: this.translate('table.' + this.entity + '.field.cep'), value: item.cep ? this.maskField(item.cep, '#####-###') : ''},
          {field: this.translate('table.' + this.entity + '.field.neighborhood'), value: item.neighborhood ? item.neighborhood : ''},
          {field: this.translate('table.' + this.entity + '.field.complement'), value: item.complement ? item.complement : ''},
          {field: this.translate('table.' + this.entity + '.field.address'), value: item.address ? item.address : ''},
          {field: this.translate('table.' + this.entity + '.field.number '), value: item.number ? item.number : ''},
          {field: this.translate('table.' + this.entity + '.field.note '), value: item.note ? item.note : ''}
        ]
      },
      // força a atualização dos items editados
      afterEditSocketManagementDetails (item) {
        if (this.editedItem.auto) {
          this.getCompanyData(true)
        }
      },
      getCompanyData (val) {
        if (val) {
          this.editedItem.rgie = this.editedItem.connection_company.rgie
          this.editedItem.city = this.editedItem.connection_company.city
          this.editedItem.state = this.editedItem.connection_company.state
          this.editedItem.country = this.editedItem.connection_company.country
          this.editedItem.address = this.editedItem.connection_company.address
          this.editedItem.number = this.editedItem.connection_company.number
          this.editedItem.neighborhood = this.editedItem.connection_company.neighborhood
          this.editedItem.complement = this.editedItem.connection_company.complement
          this.editedItem.cep = this.editedItem.connection_company.cep
          this.editedItem.phone = this.editedItem.connection_company.phone
          this.editedItem.email = this.editedItem.connection_company.email
          // Preenche o campo de cidade
          this.setAddress(this.editedItem.city, this.editedItem.state, this.editedItem.country)
        }
      }
    },
    computed: {
      dynamicFlex () {
        if (this.view === 3) {
          return `sm7`
        } else {
          return `sm9`
        }
      },
      filterTypes: function () {
        return [
          {field: 'identifier', type: 'integer'},
          {field: 'type_person', type: 'array', items: this.translate('value.connection_type_person')},
          {field: 'id_text', type: 'string'},
          {field: 'status', type: 'array', items: this.translate('value.connection_status')},
          {field: 'cpfcnpj', type: 'string', hint: 'Digite apenas números'},
          {field: 'rgie', type: 'string', hint: 'Digite apenas números'},
          {field: 'state', type: 'string', hint: 'Exemplo: SP'},
          {field: 'cep', type: 'string', hint: 'Digite apenas números'},
          {field: 'city', type: 'string'},
          {field: 'neighborhood', type: 'string'},
          {field: 'complement', type: 'string'},
          {field: 'address', type: 'string'},
          {field: 'number', type: 'integer'},
          {field: 'note', type: 'string'},
          {field: 'active', type: 'boolean'}
        ]
      },
      headers: function () {
        return [
          {text: this.translate('table.' + this.entity + '.field.identifier'), value: 'identifier', width: '5%'},
          {text: this.translate('table.' + this.entity + '.field.id_text'), value: 'id_text', width: '35%'},
          {text: this.translate('table.' + this.entity + '.field.cpfcnpj'), value: 'cpfcnpj', width: '15%'},
          {text: this.translate('table.' + this.entity + '.field.status'), value: 'status', width: '10%'},
          {text: this.translate('table.' + this.entity + '.field.main_contact'), value: 'main_contact', sortable: false},
          // O campo ativo foi ocultado da tela de parceria. Posteriormente será retrabalhado e voltará a ser exibido
          // {text: this.translate('table.' + this.entity + '.field.active'), value: 'active'},
          {text: this.translate('system.table.action'), value: 'action', sortable: false, align: 'center'}
        ]
      }
    },
    destroyed () {
      this.$socket.emit('leaveRoom', {room: `${this.entity}${this.$auth.user().company_id}`})
      // Sai das salas de gerenciamento e edição caso o usuário troque de tela enquanto ele está gerenciando/editando uma tarefa
      this.$socket.emit('leaveRoom', {room: `${this.entity}${this.$auth.user().company_id}_${this.editedItem.id}`})
      this.$socket.emit('leaveRoom', {room: `${this.entity}${this.$auth.user().company_id}_${this.editedItem.id}_edit`})
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Connection.vue